import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookSearchService = ( createDecorator('notebookSearchService'));
export { INotebookSearchService };
